import { appListenerMiddleware } from 'reduxTyped'
import { l } from '@manychat/manyui'

import { AiCommunicationsActions } from 'apps/aiCommunications/store'
import { billing, UpgradeModalVersion, UpgradeSource } from 'common/billing'
import { upgrade } from 'common/billing/actions/upgradeActions'
import { cancelUpgradeRequest } from 'common/billing/actions/upgradeRequestActions'
import { AddOnSlug } from 'common/billing/interfaces/addOnTypes'
import * as managerActions from 'common/builder/actions/manager/managerActions'
import { AI_ADDON_PUBLISH_ERROR_APPEARED } from 'common/builder/constants/builderReduxActionTypes'
import { Ability } from 'common/core/constants/Ability'
import { IThunkAction } from 'common/core/interfaces/actions'
import { getHasAbility } from 'common/core/selectors/abilitiesSelectors'

export interface SetUpAiAddonListenersOptions {
  managerId: string
}

export const SetUpAiAddonListeners =
  ({ managerId }: SetUpAiAddonListenersOptions): IThunkAction =>
  (dispatch, getState) => {
    const showModalUnsubscribe = appListenerMiddleware.startListening({
      predicate: (action) => action.type === AI_ADDON_PUBLISH_ERROR_APPEARED,
      effect: () => {
        dispatch(AiCommunicationsActions.setTriggeredBySetLive(true))
        billing.requestUpgrade({
          addOns: [AddOnSlug.AI],
          source: UpgradeSource.FLOW_PUBLISH_AI_ADDON_REQUIRED,
          customProps: {
            [UpgradeModalVersion.UPGRADE_AI]: {
              indicativeMessage: l.translate(
                'Your AI automation will go live when you start a Pro plan with AI!',
              ),
            },
            [UpgradeModalVersion.UPGRADE_AI_FROM_TRIAL]: {
              indicativeMessage: l.translate(
                'Your AI automation will go live when you start a Pro plan with AI!',
              ),
            },
          },
        })
        showModalUnsubscribe()
      },
    })

    const endActions = [upgrade.fulfilled.type, cancelUpgradeRequest.type]
    const publishFlowUnsubscribe = appListenerMiddleware.startListening({
      predicate: (action) => endActions.includes(action.type),
      effect: () => {
        if (getHasAbility(getState(), Ability.AI_AGENT)) {
          dispatch(managerActions.publish(managerId))
        }
        publishFlowUnsubscribe()
      },
    })
  }
